/* Mission testimonials split slider — syncs media + content (fmts-) */
(function () {
  'use strict';

  var prefersReduced =
    window.matchMedia &&
    window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initSlider(root) {
    var track = root.querySelector('[data-fmts-track]');
    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-fmts-slide]'));
    var medias = Array.prototype.slice.call(root.querySelectorAll('[data-fmts-media]'));
    var counter = root.querySelector('[data-fmts-counter]');
    var fill = root.querySelector('[data-fmts-progress-fill]');
    var prevBtn = root.querySelector('[data-fmts-prev]');
    var nextBtn = root.querySelector('[data-fmts-next]');

    var total = slides.length;
    if (total === 0) return;

    var loop = root.getAttribute('data-loop') === 'true';
    var autoplay = root.getAttribute('data-autoplay') === 'true';
    var autoplayMs = parseInt(root.getAttribute('data-autoplay-ms'), 10) || 6000;
    var current = 0;
    var timer = null;

    function attachVideo(media) {
      var video = media.querySelector('[data-fmts-video]');
      if (video && !video.src && video.dataset.src) {
        video.src = video.dataset.src;
      }
      return video;
    }

    function playActiveVideo() {
      medias.forEach(function (media, i) {
        var video = media.querySelector('[data-fmts-video]');
        if (!video) return;
        if (i === current) {
          attachVideo(media);
          if (!prefersReduced) {
            var p = video.play();
            if (p && p.catch) p.catch(function () {});
          }
        } else if (!video.paused) {
          video.pause();
        }
      });
    }

    function render() {
      if (track) {
        track.style.transform = 'translateX(' + -current * 100 + '%)';
      }
      slides.forEach(function (slide, i) {
        slide.classList.toggle('is-active', i === current);
        slide.setAttribute('aria-hidden', i === current ? 'false' : 'true');
      });
      medias.forEach(function (media, i) {
        media.classList.toggle('is-active', i === current);
      });
      if (counter) {
        counter.textContent = current + 1 + ' / ' + total;
      }
      if (fill) {
        fill.style.transform = 'scaleX(' + (current + 1) / total + ')';
      }
      if (!loop) {
        if (prevBtn) prevBtn.disabled = current === 0;
        if (nextBtn) nextBtn.disabled = current === total - 1;
      }
      playActiveVideo();
    }

    function goTo(index) {
      if (loop) {
        current = (index + total) % total;
      } else {
        current = Math.max(0, Math.min(index, total - 1));
      }
      render();
    }

    function next() {
      goTo(current + 1);
    }
    function prev() {
      goTo(current - 1);
    }

    function startAutoplay() {
      if (!autoplay || prefersReduced || total < 2) return;
      stopAutoplay();
      timer = window.setInterval(next, autoplayMs);
    }
    function stopAutoplay() {
      if (timer) {
        window.clearInterval(timer);
        timer = null;
      }
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        next();
        startAutoplay();
      });
    }
    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        prev();
        startAutoplay();
      });
    }

    root.addEventListener('mouseenter', stopAutoplay);
    root.addEventListener('mouseleave', startAutoplay);
    root.addEventListener('focusin', stopAutoplay);
    root.addEventListener('focusout', startAutoplay);

    // Keyboard support on the content side
    root.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') {
        prev();
        startAutoplay();
      } else if (e.key === 'ArrowRight') {
        next();
        startAutoplay();
      }
    });

    // Touch swipe on the viewport
    var viewport = root.querySelector('[data-fmts-viewport]');
    if (viewport) {
      var startX = 0;
      var moved = false;
      viewport.addEventListener(
        'touchstart',
        function (e) {
          startX = e.touches[0].clientX;
          moved = false;
        },
        { passive: true }
      );
      viewport.addEventListener(
        'touchmove',
        function (e) {
          if (Math.abs(e.touches[0].clientX - startX) > 10) moved = true;
        },
        { passive: true }
      );
      viewport.addEventListener('touchend', function (e) {
        if (!moved) return;
        var dx = e.changedTouches[0].clientX - startX;
        if (Math.abs(dx) > 40) {
          if (dx < 0) next();
          else prev();
          startAutoplay();
        }
      });
    }

    render();
    startAutoplay();
  }

  function init() {
    var roots = document.querySelectorAll('[data-fmts-slider]');
    Array.prototype.forEach.call(roots, initSlider);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-init for Shopify theme editor section loads
  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector('[data-fmts-slider]');
    if (root) initSlider(root);
  });
})();
